/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Person
 */
export interface Person {
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    normalizedUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    normalizedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    emailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    securityStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    concurrencyStamp?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    phoneNumberConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    twoFactorEnabled?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Person
     */
    lockoutEnd?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Person
     */
    lockoutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    accessFailedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    passwordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    userName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    registerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    loginUID?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Person
     */
    birthday?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    member?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    igvKennung?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    bankDebitOk?: number;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    bookingAlowed?: number;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    leisureRiderStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    helloText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    bankAccountIBAN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    bankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    bankAccountBic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    bankOwner?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Person
     */
    age?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Person
     */
    ownedHorses?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    apiKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Person
     */
    showId?: string | null;
}

/**
 * Check if a given object implements the Person interface.
 */
export function instanceOfPerson(value: object): value is Person {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function PersonFromJSON(json: any): Person {
    return PersonFromJSONTyped(json, false);
}

export function PersonFromJSONTyped(json: any, ignoreDiscriminator: boolean): Person {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'normalizedUserName': json['normalizedUserName'] == null ? undefined : json['normalizedUserName'],
        'normalizedEmail': json['normalizedEmail'] == null ? undefined : json['normalizedEmail'],
        'emailConfirmed': json['emailConfirmed'] == null ? undefined : json['emailConfirmed'],
        'securityStamp': json['securityStamp'] == null ? undefined : json['securityStamp'],
        'concurrencyStamp': json['concurrencyStamp'] == null ? undefined : json['concurrencyStamp'],
        'phoneNumberConfirmed': json['phoneNumberConfirmed'] == null ? undefined : json['phoneNumberConfirmed'],
        'twoFactorEnabled': json['twoFactorEnabled'] == null ? undefined : json['twoFactorEnabled'],
        'lockoutEnd': json['lockoutEnd'] == null ? undefined : (new Date(json['lockoutEnd'])),
        'lockoutEnabled': json['lockoutEnabled'] == null ? undefined : json['lockoutEnabled'],
        'accessFailedCount': json['accessFailedCount'] == null ? undefined : json['accessFailedCount'],
        'passwordHash': json['passwordHash'] == null ? undefined : json['passwordHash'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'email': json['email'],
        'password': json['password'],
        'registerId': json['registerId'] == null ? undefined : json['registerId'],
        'loginUID': json['loginUID'] == null ? undefined : json['loginUID'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'country': json['country'] == null ? undefined : json['country'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'member': json['member'] == null ? undefined : json['member'],
        'igvKennung': json['igvKennung'] == null ? undefined : json['igvKennung'],
        'bankDebitOk': json['bankDebitOk'] == null ? undefined : json['bankDebitOk'],
        'bookingAlowed': json['bookingAlowed'] == null ? undefined : json['bookingAlowed'],
        'leisureRiderStatus': json['leisureRiderStatus'] == null ? undefined : json['leisureRiderStatus'],
        'helloText': json['helloText'] == null ? undefined : json['helloText'],
        'bankAccountIBAN': json['bankAccountIBAN'] == null ? undefined : json['bankAccountIBAN'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'bankAccountBic': json['bankAccountBic'] == null ? undefined : json['bankAccountBic'],
        'bankOwner': json['bankOwner'] == null ? undefined : json['bankOwner'],
        'age': json['age'] == null ? undefined : json['age'],
        'ownedHorses': json['ownedHorses'] == null ? undefined : json['ownedHorses'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
        'showId': json['showId'] == null ? undefined : json['showId'],
    };
}

export function PersonToJSON(json: any): Person {
    return PersonToJSONTyped(json, false);
}

export function PersonToJSONTyped(value?: Person | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'normalizedUserName': value['normalizedUserName'],
        'normalizedEmail': value['normalizedEmail'],
        'emailConfirmed': value['emailConfirmed'],
        'securityStamp': value['securityStamp'],
        'concurrencyStamp': value['concurrencyStamp'],
        'phoneNumberConfirmed': value['phoneNumberConfirmed'],
        'twoFactorEnabled': value['twoFactorEnabled'],
        'lockoutEnd': value['lockoutEnd'] == null ? undefined : ((value['lockoutEnd'] as any).toISOString()),
        'lockoutEnabled': value['lockoutEnabled'],
        'accessFailedCount': value['accessFailedCount'],
        'passwordHash': value['passwordHash'],
        'userName': value['userName'],
        'email': value['email'],
        'password': value['password'],
        'registerId': value['registerId'],
        'loginUID': value['loginUID'],
        'phoneNumber': value['phoneNumber'],
        'street': value['street'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthday': value['birthday'] == null ? undefined : ((value['birthday'] as any).toISOString().substring(0,10)),
        'member': value['member'],
        'igvKennung': value['igvKennung'],
        'bankDebitOk': value['bankDebitOk'],
        'bookingAlowed': value['bookingAlowed'],
        'leisureRiderStatus': value['leisureRiderStatus'],
        'helloText': value['helloText'],
        'bankAccountIBAN': value['bankAccountIBAN'],
        'bankName': value['bankName'],
        'bankAccountBic': value['bankAccountBic'],
        'bankOwner': value['bankOwner'],
        'age': value['age'],
        'ownedHorses': value['ownedHorses'],
        'apiKey': value['apiKey'],
        'showId': value['showId'],
    };
}

